module.exports = __webpack_public_path__ + "img/unit4.d8e675e8.png";